<template>
  <div class="calendar-arrow-month">
    <calendar-input-day
      v-for="day in daysInMonth"
      :key="day"
      :day="getDay(day)"
      :day-width="dayWidth"
      :selected-date="selectedDate"
      :is-first-day="firstAvailableDay === getDay(day)"
      :is-day-disabled="isDayDisabled(day)"
      :current-focus="currentFocus"
      @refresh-focusable="$emit('refresh-focusable', $event)"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getDate } from '@utils/date-helpers'
import CalendarInputDay from './calendar-input-day.vue'
export default {
  name: 'calendar-input-month',
  components: {
    CalendarInputDay,
  },
  props: {
    month: {
      type: String,
      required: true
    },
    selectedDate: {
      type: String
    },
    currentFocus: {
      type: String
    },
  },
  inject: [
    'startDate',
    'disabledDates',
    'disabledWeekDates',
  ],
  data: () => ({
    width: 0,
    dayWidth: 0,
    isActive: false
  }),
  computed: {
    ...mapGetters('booking', ['monthFormat']),
    ...mapGetters('i18n', ['tc']),
    monthInDate() {
      return getDate(this.month, this.monthFormat)
    },
    year() {
      return this.monthInDate.year()
    },
    daysInMonth() {
      return this.monthInDate.daysInMonth()
    },
    firstAvailableDay() {
      let isAvailable = false
      for (let i = 1; i < this.daysInMonth; i++) {
        const isDisabled = this.isDayDisabled(i)
        if (!isDisabled) {
          isAvailable = this.getDay(i)
          break
        }
      }
      return isAvailable
    },
    monthIndex() {
      return this.monthInDate.month() + 1
    },
    isLoading() {
      return this.month === this.calendarLoading
    }
  },
  mounted() {
    const elBounding = this.$el.getBoundingClientRect()
    this.width = elBounding.width
    this.dayWidth = (this.width / 7) - 16
  },
  methods: {
    getDay(day) {
      return getDate([this.year, this.monthInDate.month(), day]).format()
    },
    isDayDisabled(day) {
      const dayObj = getDate(this.getDay(day))
      const weekDay = dayObj.format('E')
      return this.disabledWeekDates.includes(Number(weekDay))
    }
  }
}
</script>
